<template lang="pug">
  el-breadcrumb.app-breadcrumb(separator="/")
    transition-group(name="breadcrumb")
      el-breadcrumb-item(v-for="(item,index) in levelList"
                        v-if="item.meta.title"
                        :key="item.path")
        span.no-redirect(v-if="item.redirect==='noredirect' || index == levelList.length - 1") {{ item.meta.title}}
        router-link(v-else :to="item.redirect || item.path") {{ item.meta.title}}
</template>
<script>
import pathToRegexp from 'path-to-regexp'

export default {
  data () {
    return {
      levelList: null
    }
  },
  name: 'Breadcrumb',
  watch: {
    $route () {
      this.getBreadcrumb()
    }
  },
  created () {
    this.getBreadcrumb()
  },
  methods: {
    getBreadcrumb () {
      const { params } = this.$route
      let matched = this.$route.matched.filter(item => {
        if (item.name) {
          // To solve this problem https://github.com/PanJiaChen/vue-element-admin/issues/561
          var toPath = pathToRegexp.compile(item.path)
          item.path = toPath(params)
          return true
        }
      })
      const first = matched[0]
      if (first && first.name !== 'home') {
        matched = [{ path: '/', meta: { title: 'Home' } }].concat(matched)
      }
      this.levelList = matched
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 14px;
  line-height: 50px;
  margin-left: 10px;
  min-width: 200px;

  .no-redirect {
    color: #97a8be;
    cursor: text;
  }
}
</style>
